import { callable } from './callable.js'
import type { EduAttachmentRef } from './eduFeedService.js'

export type PortfolioItemKind = 'HOMEWORK' | 'FEED' | 'CERTIFICATE' | 'PRACTICE'

export interface EduPortfolioItem {
  id: string
  workspaceId: string
  learnerId: string
  kind: PortfolioItemKind
  sourceId: string
  date: unknown
  title: string
  summary: string
  attachments: EduAttachmentRef[]
  certificateId?: string
  code?: string
  staffHidden: boolean
  pinned: boolean
  pinnedAt: unknown | null
  updatedAt: unknown
}

export interface GetEduPortfolioInput {
  workspaceId: string
  learnerId: string
  cursor?: string
  pageSize?: number
}

export interface GetEduPortfolioResult {
  pinnedItems: EduPortfolioItem[]
  items: EduPortfolioItem[]
  hiddenItems?: EduPortfolioItem[]
  nextCursor: string | null
}

export interface SetEduPortfolioItemFlagsInput {
  workspaceId: string
  learnerId: string
  itemId: string
  hidden?: boolean
  pinned?: boolean
}

export interface SetEduPortfolioItemFlagsResult {
  success: boolean
  item: EduPortfolioItem
}

export interface GetEduPortfolioPdfUrlInput {
  workspaceId: string
  learnerId: string
}

export interface GetEduPortfolioPdfUrlResult {
  url: string
  pdfUrl: string
  storagePath: string
  contentHash: string
}

export interface BackfillEduPortfolioInput {
  workspaceId: string
  cursor?: string
  pageSize?: number
}

export interface BackfillEduPortfolioResult {
  success: boolean
  nextCursor: string | null
  count: number
}

export async function getEduPortfolio(
  input: GetEduPortfolioInput,
): Promise<GetEduPortfolioResult> {
  return callable('getEduPortfolio', input)
}

export async function setEduPortfolioItemFlags(
  input: SetEduPortfolioItemFlagsInput,
): Promise<SetEduPortfolioItemFlagsResult> {
  return callable('setEduPortfolioItemFlags', input)
}

export async function getEduPortfolioPdfUrl(
  input: GetEduPortfolioPdfUrlInput,
): Promise<GetEduPortfolioPdfUrlResult> {
  return callable('getEduPortfolioPdfUrl', input)
}

export async function backfillEduPortfolio(
  input: BackfillEduPortfolioInput,
): Promise<BackfillEduPortfolioResult> {
  return callable('backfillEduPortfolio', input)
}

export interface SetEduPortfolioFamilyHideInput {
  workspaceId: string
  learnerId: string
  itemId: string
  hidden: boolean
}

export interface SetEduPortfolioFamilyHideResult {
  success: boolean
}

export async function setEduPortfolioFamilyHide(
  input: SetEduPortfolioFamilyHideInput,
): Promise<SetEduPortfolioFamilyHideResult> {
  return callable('setEduPortfolioFamilyHide', input)
}

